import { KeyValue } from "@/main/models/common";
import { ClaimFileCategoryTypes, ClaimFileCategoryActionTypes } from "./claimFileCategoryTypes";

export function getClaimFileCategory(): ClaimFileCategoryActionTypes {
	return {
		type: ClaimFileCategoryTypes.GET_CLAIM_FILE_CATEGORY,
	};
}

export function saveClaimFileCategory(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): ClaimFileCategoryActionTypes {
	return {
		type: ClaimFileCategoryTypes.SAVE_CLAIM_FILE_CATEGORY,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerClaimFileCategory(): ClaimFileCategoryActionTypes {
	return {
		type: ClaimFileCategoryTypes.RESET_REDUCER_CLAIM_FILE_CATEGORY,
	};
}
